export default __webpack_public_path__ + "static/media/checked.8f45b4c6.svg";